// @flow
import reject from 'lodash/fp/reject';

import * as at from '../actions/action-types';
import type { State as TopLevelState, Action } from '../store';

import type { ManagedUser } from 'modules/user';

export type State = { isLoading: boolean, data: Array<ManagedUser> };

export const getManagedUsers = (state: TopLevelState): State =>
  state.managedUsers;

export const initialState: State = {
  isLoading: false,
  data: [],
};

/* 🤔 could probably DRY this up by using a custom combineReducers or something */
const managedUsers = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case at.RESOURCE_REQUEST:
      return action.payload.method === 'GET' &&
        action.payload.resourceName === 'MANAGED_USERS'
        ? { ...state, isLoading: true }
        : state;

    case at.RESOURCE_FAIL_TO_RECEIVE:
      return action.payload.method === 'GET' &&
        action.payload.resourceName === 'MANAGED_USERS'
        ? { ...state, isLoading: false }
        : state;

    case at.RESOURCE_RECEIVE:
      if (
        action.payload.method === 'GET' &&
        action.payload.resourceName === 'MANAGED_USERS'
      ) {
        const { data } = action.payload;
        // eslint-disable-next-line babel/no-unused-expressions
        (data: Array<ManagedUser>);
        return {
          isLoading: false,
          data,
        };
      }
      if (
        action.payload.method === 'PUT' &&
        (action.payload.resourceName === 'MANAGED_USERS' ||
          action.payload.resourceName === 'USER')
      ) {
        const { data } = action.payload;
        // eslint-disable-next-line babel/no-unused-expressions
        (data: { id: string });
        return {
          ...state,
          data: state.data.map((user: ManagedUser): ManagedUser =>
            user.id === data.id ? { ...user, ...data } : user,
          ),
        };
      }
      if (
        action.payload.method === 'DELETE' &&
        (action.payload.resourceName === 'MANAGED_USERS' ||
          action.payload.resourceName === 'USER')
      ) {
        const { data } = action.payload;
        // eslint-disable-next-line babel/no-unused-expressions
        (data: { id: string });
        return {
          ...state,
          data: reject<ManagedUser>(({ id }: ManagedUser) => id === data.id)(
            state.data,
          ),
        };
      }
      return state;

    case at.UPDATE_USER_IS_DISABLED:
      return {
        ...state,
        data: state.data.map((user: ManagedUser): ManagedUser =>
          user.id === action.payload.id
            ? { ...user, isDisabled: !user.isDisabled }
            : user,
        ),
      };

    case at.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default managedUsers;
